<!-- Overlay -->
<div *ngIf="open" class="fixed inset-0 z-[99999] flex items-center justify-center overflow-y-auto p-5" role="dialog"
  aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-desc">

  <!-- Backdrop -->
  <div class="fixed inset-0 h-full w-full bg-gray-400/50 backdrop-blur-[2px]" (click)="onBackdropClick()"></div>

  <!-- Modal -->
  <div class="relative w-full max-w-[580px] rounded-3xl bg-white p-6 lg:p-10 dark:bg-gray-900">

    <!-- Close btn -->
    <button type="button" (click)="onCancel()"
      class="absolute top-3 right-3 z-[999] flex h-9.5 w-9.5 items-center justify-center rounded-full bg-gray-100 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-700 sm:top-6 sm:right-6 sm:h-11 sm:w-11 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
      aria-label="Cerrar">
      <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6.043 16.541c-.391.39-.391 1.023 0 1.414.39.39 1.023.39 1.414 0L12 13.414l4.543 4.542c.39.391 1.023.391 1.414 0 .39-.39.39-1.023 0-1.414L13.414 12l4.543-4.542c.39-.391.39-1.024 0-1.415-.391-.39-1.024-.39-1.414 0L12 10.586 7.457 6.043c-.39-.39-1.023-.39-1.414 0-.391.391-.391 1.024 0 1.415L10.586 12 6.043 16.541Z" />
      </svg>
    </button>

    <div class="text-center">
      <!-- Icono -->
      <div class="relative z-[1] mb-7 flex items-center justify-center">
        @if (variant === 'warning') {
        <!-- Warning Icon -->
        <svg class="fill-amber-50 dark:fill-amber-500/15" width="90" height="90" viewBox="0 0 90 90">
          <path
            d="M34.364 6.851C38.621-2.283 51.379-2.283 55.636 6.851c2.377 5.1 7.924 7.821 13.32 6.534 9.664-2.304 17.619 7.859 13.263 16.944-2.432 5.073-1.062 11.188 3.29 14.683 7.794 6.26 4.955 18.932-4.733 21.128-5.41 1.226-9.248 6.129-9.217 11.775.055 10.111-11.44 15.751-19.166 9.403-4.314-3.545-10.47-3.545-14.783 0-7.725 6.348-19.221.708-19.166-9.403.031-5.646-3.807-10.549-9.217-11.775C-0.463 63.945-3.302 51.273 4.492 45.012c4.352-3.496 5.722-9.61 3.29-14.684C3.426 21.243 11.381 11.081 21.044 13.385c5.396 1.287 10.943-1.434 13.32-6.534Z" />
        </svg>
        <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <svg class="fill-amber-600 dark:fill-amber-500" width="38" height="38" viewBox="0 0 38 38">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M19 8.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-3 0V10a1.5 1.5 0 0 1 1.5-1.5ZM19 25.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
          </svg>
        </span>
        } @else {
        <!-- Error/Danger Icon -->
        <svg class="fill-error-50 dark:fill-error-500/15" width="90" height="90" viewBox="0 0 90 90">
          <path
            d="M34.364 6.851C38.621-2.283 51.379-2.283 55.636 6.851c2.377 5.1 7.924 7.821 13.32 6.534 9.664-2.304 17.619 7.859 13.263 16.944-2.432 5.073-1.062 11.188 3.29 14.683 7.794 6.26 4.955 18.932-4.733 21.128-5.41 1.226-9.248 6.129-9.217 11.775.055 10.111-11.44 15.751-19.166 9.403-4.314-3.545-10.47-3.545-14.783 0-7.725 6.348-19.221.708-19.166-9.403.031-5.646-3.807-10.549-9.217-11.775C-0.463 63.945-3.302 51.273 4.492 45.012c4.352-3.496 5.722-9.61 3.29-14.684C3.426 21.243 11.381 11.081 21.044 13.385c5.396 1.287 10.943-1.434 13.32-6.534Z" />
        </svg>
        <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <svg class="fill-error-600 dark:fill-error-500" width="38" height="38" viewBox="0 0 38 38">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.627 11.75a1.5 1.5 0 0 1 2.121-2.122l7.25 7.251 7.25-7.25a1.5 1.5 0 1 1 2.121 2.121L21.12 19l7.25 7.25a1.5 1.5 0 0 1-2.121 2.121L19 21.12l-7.252 7.25a1.5 1.5 0 1 1-2.121-2.121L16.877 19 9.627 11.75Z" />
          </svg>
        </span>
        }
      </div>

      <!-- Título y subtítulo -->
      <h4 id="confirm-title" class="sm:text-title-sm mb-2 text-2xl font-semibold text-gray-800 dark:text-white/90">
        {{ title }}
      </h4>
      <p id="confirm-desc" class="text-sm leading-6 text-gray-500 dark:text-gray-400">
        {{ subtitle }}
      </p>

      <!-- Botones -->
      <div class="mt-8 flex w-full items-center justify-center gap-3">
        <button type="button" (click)="onCancel()" [disabled]="loading"
          class="shadow-theme-xs flex justify-center rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
          {{ cancelText }}
        </button>

        <button #confirmBtn type="button" (click)="onConfirm()" [disabled]="loading" [ngClass]="confirmBtnClasses">
          <ng-container *ngIf="!loading; else loadingTpl">{{ confirmText }}</ng-container>
          <ng-template #loadingTpl>
            <span class="animate-pulse">Procesando…</span>
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</div>
